import { render, staticRenderFns } from "./BnetErrorAlert.vue?vue&type=template&id=310e40db&scoped=true&"
import script from "./BnetErrorAlert.vue?vue&type=script&lang=js&"
export * from "./BnetErrorAlert.vue?vue&type=script&lang=js&"
import style0 from "./BnetErrorAlert.vue?vue&type=style&index=0&id=310e40db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310e40db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VList,VListItem,VListItemContent,VListItemIcon,VRow})
